import React from 'react';
import Const from 'constants';
import {Table as ClassicTable} from './classic';

let PlayersList = {
    get(sportConfig) {
        if (sportConfig.isGameTypeClassic()) {
            return ClassicTable;
        }

        throw new Error(`get ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {PlayersList};
